import {Component, HostListener, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {Subscription} from 'rxjs';
import {FormControl, UntypedFormBuilder, Validators} from '@angular/forms';
import {RestoreDataService} from '../../original-services/restore-data.service';
import {LoggerService} from '../../original-services/logger.service';
import {STATE_NAMES} from '../../common/state-names';
import {ButtonStyle} from '../../components/ui/text-button/text-button.component';
import {EMAIL_PATTERN} from 'app/common/patterns';
import {ReCaptchaV3Service} from 'ng-recaptcha-2';
import {SettingsService} from '../../original-services/settings.service';

@Component({
    selector: 'page-restoring',
    templateUrl: './restoring.component.html',
    styleUrls: ['./restoring.component.scss'],
    standalone: false
})
export class RestoringPageComponent implements OnInit, OnDestroy {

    buttonStyle = ButtonStyle;
    signInState = STATE_NAMES.login;
    email: FormControl;
    submitPressed = false;
    isSubmitting = false;
    errorMessage?: string;
    isSend = false;
    isRememberedPassword = true;

    private emailChangesSubscription: Subscription;

    constructor(
        private fb: UntypedFormBuilder,
        private restoreService: RestoreDataService,
        private logger: LoggerService,
        private settingsService: SettingsService,
        private recaptchaV3Service: ReCaptchaV3Service,
        private renderer: Renderer2
    ) {
        this.email = this.fb.control(null, [Validators.required, Validators.pattern(EMAIL_PATTERN)]);

        // Clears the message on typing; the field keeps its red border until the address is valid.
        this.emailChangesSubscription = this.email.valueChanges.subscribe(() => {
            this.errorMessage = undefined;
        });
    }

    @HostListener('document:keydown.enter')
    onKeyEnter() {
        this.sendEmail();
    }


    ngOnInit() {
        if (!this.settingsService.hideRecaptcha) {
            this.renderer.addClass(document.body, 'show-recaptcha');
        }
    }

    sendEmail() {
        // Enter fires this twice (keydown listener + the form's implicit submit). Set before the
        // reCAPTCHA hop below, so the duplicate can't slip through while the token is fetched.
        if (this.isSubmitting || this.isSend) {
            return;
        }
        this.submitPressed = true;
        if (this.email.valid) {
            this.errorMessage = undefined;
            this.isSubmitting = true;
            if (this.settingsService.hideRecaptcha) {
                this.resolved();
            } else {
                this.logger.log(`Captcha reseting`);
                this.recaptchaV3Service
                    .execute('importantAction')
                    .subscribe((token: string) => {
                        this.logger.log(`Captcha executed`);
                        this.resolved(token);
                    });
            }
        } else if (this.email.value) {
            this.errorMessage = `RestorePassword.Form.EmailError`;
        }
    }

    resolved(token?: string) {
        this.restoreService.sendEmail({
            recaptcha_response: token,
            email: this.email.value
        }).subscribe({
            next: () => {
                this.isSubmitting = false;
                this.isRememberedPassword = false;
                this.isSend = true;
            },
            error: (error: any) => {
                this.isSubmitting = false;
                this.isSend = false;
                this.errorMessage = `RestorePassword.Form.ErrorDefault`;
                this.logger.error(error);
            }
        })
    }

    ngOnDestroy() {
        this.renderer.removeClass(document.body, 'show-recaptcha');
        if (this.emailChangesSubscription) {
            this.emailChangesSubscription.unsubscribe();
        }
    }

}
